import axios from "axios";
import axiosRetry from "axios-retry";
import toastr from "toastr";
import * as actions from "./actionsTypes";
import errorManage from "../errorManage";
import messages from "../../redux/messages";
import GestorDocumentalServices from "../../redux/gestorDocumental/gestorDocumental.services";
import EmployeesServices from "./employees.services";
import employeesServices from "./employees.services";
import moment from "moment";
import { getEmployeesHierarchy } from "../employeesHierarchy/actions";

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getAllEmployees = (filter) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: true,
    });
    const resp = await EmployeesServices.getAllEmployees(filter);
    dispatch({
      type: actions.GET_EMPLOYEES,
      payload: {
        employees: resp.data.data,
        employeesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: false,
    });
  }
};

export const getAllActiveEmployees = (filter) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: true,
    });
    const resp = await EmployeesServices.getAllActiveEmployees(filter);
    dispatch({
      type: actions.GET_EMPLOYEES,
      payload: {
        employees: resp.data.data,
        employeesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: false,
    });
  }
};

export const clearEmployees = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: true,
    });

    dispatch({
      type: actions.GET_EMPLOYEES,
      payload: {
        employees: [],
        employeesLength: 0
      },
    });
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.GET_ALL_EMPLOYEES_FAILD,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_ALL_EMPLOYEES,
      payload: false,
    });
  }
};

export const getEmployees = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEES,
      payload: true,
    });
    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    const resp = await client.get(
      iType === 1
        ? "/api/app/Formal_empleado/"
        : `/api/app/Funcional_empleado/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        params: data,
      }
    );
    dispatch({
      type: actions.GET_EMPLOYEES,
      payload: {
        employees: resp.data.data,
        employeesLength: resp.data.count,
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEES,
      payload: false,
    });
  }
};

async function _getEmployee(id, itype, token) {
  const resp = await client.get(
    itype === 1
      ? `/api/app/Formal_empleado/${id}`
      : `/api/app/Funcional_empleado/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    }
  );
  return resp;
}

export const getEmployee = (id, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEES,
      payload: true,
    });
    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    const resp = await _getEmployee(id, itype, token);

    dispatch({
      type: actions.GET_EMPLOYEE,
      payload: resp.data,
    });
  } catch (ex) {
    console.log(ex);
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEES,
      payload: false,
    });
  }
};

export const saveEmployee =
  (data, iType, reqEstadoCivilGD, reqCroquisGD) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: actions.SAVE_LOADING_EMPLOYEES,
          payload: true,
        });
        const { token } =
          getState().auth || localStorage.getItem("auth")
            ? JSON.parse(localStorage.getItem("auth"))
            : { token: "" };
        const resp = await client.post(
          iType === 1
            ? "/api/app/Formal_empleado/"
            : "/api/app/Funcional_empleado_mantenimiento/",
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        const { employees, employeesLength } = getState().employees;

        let callBackGetUserPerfil = false;
        let callBackGetCroquis = false;

        if (reqEstadoCivilGD) {
          if (
            resp.data.empresa &&
            resp.data.empresa.length > 0 &&
            resp.data.Division_Personal_List &&
            resp.data.Division_Personal_List.length > 0 &&
            resp.data.id
          ) {
            reqEstadoCivilGD.empresa = resp.data.empresa[0];
            reqEstadoCivilGD.zona =
              resp.data.Division_Personal_List[0].descripcion;
            reqEstadoCivilGD.id_empleado = resp.data.id;
            await GestorDocumentalServices.saveDocument(reqEstadoCivilGD);
            callBackGetUserPerfil = true;
          }
        }

        if (reqCroquisGD) {
          if (
            resp.data.empresa &&
            resp.data.empresa.length > 0 &&
            resp.data.Division_Personal_List &&
            resp.data.Division_Personal_List.length > 0 &&
            resp.data.id
          ) {
            reqCroquisGD.empresa = resp.data.empresa[0];
            reqCroquisGD.zona = resp.data.Division_Personal_List[0].descripcion;
            reqCroquisGD.id_empleado = resp.data.id;
            await GestorDocumentalServices.saveDocument(reqCroquisGD);
            callBackGetCroquis = true;
          }
        }

        let aEmployees = [];

        const userPerf = await _getEmployee(resp.data.id, iType, token);
        aEmployees = [...employees, userPerf.data];


        dispatch({
          type: actions.GET_EMPLOYEES,
          payload: {
            employees: aEmployees,
            employeesLength: employeesLength + 1,
          },
        });
        dispatch(getEmployeesHierarchy(iType));
        toastr.success(messages.successMessage);
      } catch (ex) {
        if (ex.response) {
          if (ex.response.status === 400) {
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
          } else {
            errorManage(ex);
          }
        } else {
          errorManage(ex);
        }
      } finally {
        dispatch({
          type: actions.SAVE_LOADING_EMPLOYEES,
          payload: false,
        });
      }
    };

export const editEmployee =
  (data, item, index, iType, reqEstadoCivilGD, reqCroquisGD, arGD) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: actions.SAVE_LOADING_EMPLOYEES,
          payload: true,
        });
        if (reqEstadoCivilGD) {
          await GestorDocumentalServices.saveDocument(reqEstadoCivilGD);
        }
        //debugger;
        if (reqCroquisGD) {
          if (arGD) {
            await GestorDocumentalServices.editDocument(arGD[0].id, reqCroquisGD);
          } else {
            await GestorDocumentalServices.saveDocument(reqCroquisGD);
          }
        }

        const { token } =
          getState().auth || localStorage.getItem("auth")
            ? JSON.parse(localStorage.getItem("auth"))
            : { token: "" };
        const resp = await client.put(
          iType === 1
            ? `/api/app/Formal_empleado/${item.id}/`
            : `/api/app/Funcional_empleado_mantenimiento/${item.id}/`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        const { employees, employeesLength } = getState().employees;
        const newEmployees = [...employees]

        if (
          resp.data.fecha_baja &&
          moment(resp.data.fecha_baja).format("YYYY-MM-DD") <=
          moment().format("YYYY-MM-DD") &&
          resp.data.fecha_baja !== item.fecha_baja
        ) {
          await employeesServices.dadoBajaHeadClima({
            codigo_empleado: resp.data.codigo,
          });
        }
        const employeeData = await _getEmployee(resp.data.id, iType, token);

        newEmployees[index] = employeeData.data
        //const aJobPositions = [...jobPositions, resp.data];
        dispatch({
          type: actions.GET_EMPLOYEES,
          payload: {
            employees: newEmployees,
            employeesLength: employeesLength,
          },
        });
        dispatch(getEmployeesHierarchy(iType));
        toastr.success(messages.successMessage);
        if (resp.data.fecha_baja && resp.data.fecha_baja !== item.fecha_baja) {
          const mail = {
            data: [
              {
                empleado_codigo: resp.data.codigo,
                tipo_mensaje: "Vacante nueva",
                fecha_baja: resp.data.fecha_baja,
              },
            ],
          };
          const _mail = {
            data: [
              {
                empleado_codigo: resp.data.codigo,
                tipo_mensaje: "Jefe del Responsable : Vacante nueva",
                fecha_baja: resp.data.fecha_baja,
              },
            ],
          };
          await EmployeesServices.mailSendRequirementsMonitor(mail);
          await EmployeesServices.mailSendRequirementsMonitor(_mail);
          toastr.success(messages.correoEnviado, "", {
            progressBar: true,
            rtl: true,
          });
        }
      } catch (ex) {
        if (ex.response) {
          if (ex.response.status === 400) {
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
          } else {
            errorManage(ex);
          }
        } else {
          errorManage(ex);
        }
      } finally {
        dispatch({
          type: actions.SAVE_LOADING_EMPLOYEES,
          payload: false,
        });
      }
    };

export const editEmployeeFic =
  (data, id, iType) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_EMPLOYEES,
        payload: true,
      });

      const { token } =
        getState().auth || localStorage.getItem("auth")
          ? JSON.parse(localStorage.getItem("auth"))
          : { token: "" };
      const resp = await client.put(
        iType === 1
          ? `/api/app/Formal_empleado_foto/${id}/`
          : `/api/app/Funcional_empleado_foto/${id}/`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );

      const { employee } = getState().employees;
      //const aJobPositions = [...jobPositions, resp.data];
      dispatch({
        type: actions.GET_EMPLOYEE,
        payload: { ...employee, foto: resp.data.foto },
      });
      const localAuth = localStorage.getItem("auth");
      if (localAuth) {
        localStorage.setItem(
          "auth",
          JSON.stringify({
            ...JSON.parse(localAuth),
            pic: `${process.env.REACT_APP_URL}/media/${resp.data.foto}`,
          })
        );
      }
      toastr.success(messages.successMessage);
    } catch (ex) {
      console.log(ex.message);
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_EMPLOYEES,
        payload: false,
      });
    }
  };

export const deleteEmployee =
  (id, index, iType) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EMPLOYEES,
        payload: true,
      });

      const { token } =
        getState().auth || localStorage.getItem("auth")
          ? JSON.parse(localStorage.getItem("auth"))
          : { token: "" };
      await client.delete(
        iType === 1
          ? `/api/app/Formal_empleado/${id}/`
          : `/api/app/Funcional_empleado/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      const { employees, employeesLength } = getState().employees;
      employees.splice(index, 1);
      //const aJobPositions = [...jobPositions, resp.data];
      dispatch({
        type: actions.GET_EMPLOYEES,
        payload: {
          employees: employees,
          employeesLength: employeesLength - 1,
        },
      });
      toastr.success(messages.successMessage);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_EMPLOYEES,
        payload: false,
      });
    }
  };

export const getGlobalEmployees =
  (data, iType) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EMPLOYEES,
        payload: true,
      });
      const { token } =
        getState().auth || localStorage.getItem("auth")
          ? JSON.parse(localStorage.getItem("auth"))
          : { token: "" };
      const resp = await client.get(
        iType === 1
          ? "/api/app/Formal_busqueda_empleado/"
          : "/api/app/Funcional_busqueda_empleado",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
          params: data,
        }
      );
      dispatch({
        type: actions.GET_EMPLOYEES,
        payload: {
          employees: resp.data.data,
          employeesLength: resp.data.count,
        },
      });
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_EMPLOYEES,
        payload: false,
      });
    }
  };
